import { ReactNode } from "react";

import ViewHeader from "components/ViewHeader";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import Button from "ds/components/Button";
import SearchInput from "components/SearchInput";
import { SEARCH_PLACEHOLDERS } from "constants/searchPlaceholders";

import { showCreateSpaceliftVcsRepoDrawer } from "./CreateDrawer";
import { FILTERS_ORDER_SETTINGS_KEY } from "./constants";

type SpaceliftVcsReposPageLayoutProps = {
  children: ReactNode;
  pageIsEmpty?: boolean;
};

const SpaceliftVcsReposPageLayout = ({
  children,
  pageIsEmpty = false,
}: SpaceliftVcsReposPageLayoutProps) => {
  return (
    <>
      <ViewHeader firstLevel>
        <ViewHeaderWrapper>
          <ViewHeaderTitle>Repos</ViewHeaderTitle>
        </ViewHeaderWrapper>

        <ViewHeaderWrapper>
          <SearchInput
            placeholder={SEARCH_PLACEHOLDERS.REPOSITORIES}
            filtersOrderSettingsKey={FILTERS_ORDER_SETTINGS_KEY}
            disabled={pageIsEmpty}
          />

          <Button variant="primary" onPress={() => showCreateSpaceliftVcsRepoDrawer()}>
            Create repository
          </Button>
        </ViewHeaderWrapper>
      </ViewHeader>

      {children}
    </>
  );
};

export default SpaceliftVcsReposPageLayout;
